// user.module
export const FETCH_USER_INFO = "fetchUserInfo"
export const LOGOUT_USER = "logoutUser"
export const UNLINK_DISCORD = "unlinkDiscord"
export const LINK_DISCORD = "linkDiscord"